<template>

    <div class="guest-page">

        <header class="guest-header">
            <a href="https://halsoresurs.se" class="guest-logo-link">
                <img src="/images/card/logo.svg" class="logo" alt="Hälsoresurs">
            </a>
        </header>

        <div class="guest-wrap">
            <div class="guest-card">
                <transition name="guest-fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </div>
        </div>

    </div>

</template>

<script>
// Gives the whole document the guest grey, so it continues below the
// gradient when scrolling/overscrolling past the content.
export default {

    mounted () {
        document.body.classList.add('guest-body')
    },

    beforeDestroy () {
        document.body.classList.remove('guest-body')
    }

}
</script>